export function array2Map(arr, keyName) {
  return arr.reduce((p, c) => p.set(c[keyName], c), new Map());
}
